import { getColorAbbreviation } from "./leaderManager";

// Nickname mappings for leaders
const NICKNAME_MAPPINGS: Record<string, string[]> = {
  "Donquixote Rosinante": ["Corazon"],
  "Edward.Newgate": ["Whitebeard", "WB"],
  "Monkey.D.Luffy": ["Luffy", "Straw Hat"],
  "Roronoa.Zoro": ["Zoro", "Pirate Hunter"],
  Nami: ["Cat Burglar"],
  Usopp: ["Sogeking", "God Usopp"],
  Sanji: ["Black Leg"],
  "Tony.Tony.Chopper": ["Chopper"],
  "Nico.Robin": ["Robin", "Devil Child"],
  Franky: ["Cyborg"],
  Brook: ["Soul King"],
  Jinbe: ["Knight of the Sea"],
  "Trafalgar.Law": ["Law", "Surgeon of Death"],
  "Donquixote.Doflamingo": ["Dof", "Doffy", "Heavenly Demon"],
  "Charlotte.Katakuri": ["Katakuri"],
  Kaido: ["King of Beasts"],
  "Big.Mom": ["Linlin", "BM"],
  "Gol.D.Roger": ["Roger", "Pirate King"],
  "Portgas.D.Ace": ["Ace", "Fire Fist"],
  Sabo: ["Chief of Staff"],
  Kuzan: ["Aokiji"],
  Sakazuki: ["Akainu"],
  Borsalino: ["Kizaru"],
  Issho: ["Fujitora"],
  Aramaki: ["Ryokugyu"],
  "Marshall.D.Teach": ["Blackbeard", "BB"],
};

/**
 * Enhanced filtering function that checks name, nicknames, and color abbreviations
 * Works with items that have a searchableString property
 */
export const filterLeaders = (items: any[], inputValue: string) => {
  if (!inputValue) return items;

  const searchTerms = inputValue.toLowerCase().split(" ");

  return items.filter((item) => {
    const searchableString =
      item.searchableString || item.name?.toLowerCase() || "";

    // Check if all search terms are found in the searchable string
    return searchTerms.every((term) => searchableString.includes(term));
  });
};
